import { ChangeDetectionStrategy, Component, Inject, Input, OnInit } from '@angular/core';
import { TranslateDirective } from '@ngx-translate/core';

import { HelpLinkDirective } from '../../../../components/help-link/help-link.directive';
import { OverlayComponent } from '../../../../components/overlay/overlay.component';
import { OverlayToggleDirective } from '../../../../components/overlay/overlay-toggle.directive';
import { ANALYST_RATING_CONFIGURATION, AnalystRatingConfiguration } from './analyst-rating.component';

@Component({
  selector: 'td-wb-analyst-ratings-tooltip',
  templateUrl: 'analyst-rating-tooltip.component.html',
  styleUrls: ['analyst-rating-tooltip.component.scss'],
  imports: [
    OverlayToggleDirective,
    TranslateDirective,
    OverlayComponent,
    HelpLinkDirective
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnalystRatingTooltipComponent implements OnInit {
  @Input() position: string = 'center-right';

  newAnalystRatings: boolean;

  constructor(@Inject(ANALYST_RATING_CONFIGURATION) private analystRatingsConfiguration: AnalystRatingConfiguration) {}

  ngOnInit(): void {
    this.newAnalystRatings = this.analystRatingsConfiguration !== undefined && this.analystRatingsConfiguration.newAnalystRatings;
  }
}
